// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cartograms__container {
    height: 100%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .cartograms__actions {
    justify-content: flex-end;
  }
  .cartograms__body {
    height: 100%;
    overflow: auto;
  }
  .cartograms__loader {
    display: flex;
    justify-content: center;
    align-items: center;
  }
.cartogram__action__list {
  display: flex;
  flex-direction: row;
  gap: 8px;

  /* этот падинг нужен чтобы корректно отображалась анимация ant.d-кнопок при нажатии */
  padding: 8px 8px;
}
.cartogram__action__list .cartogram__action__list__button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    width: 36px;
    height: 36px;
    /* TODO: Хранить и переиспользовать цвета */
    background: #4453711a;
    color: #445371;
  }
.cartogram__action__list .cartogram__action__list__button:focus,
    .cartogram__action__list .cartogram__action__list__button:active {
      outline: 0;
      border: none;
      transition: none;
    }

.cartogram__filters {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cartogram__filters__errors {
    display: flex;
    flex-direction: column;
    gap: 8px;
    /* TODO: Хранить и переиспользовать цвета */
    color: #d91528;
  }

.cartogram-table {
  max-height: 100%;
  width: 100%;
  overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/Module/Cartograms/components/style.scss"],"names":[],"mappings":"AACE;IACE,YAAY;IACZ,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EAEA;IACE,yBAAyB;EAC3B;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,qFAAqF;EACrF,gBAAgB;AAoBlB;AAlBE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,qBAAqB;IACrB,cAAc;EAQhB;AANE;;MAEE,UAAU;MACV,YAAY;MACZ,gBAAgB;IAClB;;AAIJ;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AASV;;AAPE;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,2CAA2C;IAC3C,cAAc;EAChB;;AAGF;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB","sourcesContent":[".cartograms {\n  &__container {\n    height: 100%;\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__actions {\n    justify-content: flex-end;\n  }\n\n  &__body {\n    height: 100%;\n    overflow: auto;\n  }\n\n  &__loader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n}\n.cartogram__action__list {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n\n  /* этот падинг нужен чтобы корректно отображалась анимация ant.d-кнопок при нажатии */\n  padding: 8px 8px;\n\n  & &__button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n    width: 36px;\n    height: 36px;\n    /* TODO: Хранить и переиспользовать цвета */\n    background: #4453711a;\n    color: #445371;\n\n    &:focus,\n    &:active {\n      outline: 0;\n      border: none;\n      transition: none;\n    }\n  }\n}\n\n.cartogram__filters {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  &__errors {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    /* TODO: Хранить и переиспользовать цвета */\n    color: #d91528;\n  }\n}\n\n.cartogram-table {\n  max-height: 100%;\n  width: 100%;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
